import React from 'react';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
import { Button } from '../../../designSystem/Button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../designSystem/Dialog';

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  propertyName: string;
  onDownloadExcel: () => void;
  isExcelExporting?: boolean;
}

export const DownloadModal: React.FC<DownloadModalProps> = ({
  isOpen,
  onClose,
  propertyName,
  onDownloadExcel,
  isExcelExporting = false,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Download className="w-5 h-5" />
            Download Report
          </DialogTitle>
          <DialogDescription>
            Download the health score report for {propertyName}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          {/* Excel Download Option */}
          <div className="border rounded-lg p-4">
            <div className="flex items-center gap-3 mb-2">
              <FileSpreadsheet className="w-5 h-5 text-green-600" />
              <span className="font-medium">Excel Data</span>
            </div>
            <p className="text-sm text-gray-600 mb-3">
              Raw data with daily prices, ranks, and property details for analysis
            </p>
            <Button 
              onClick={onDownloadExcel}
              className="w-full"
              disabled={isExcelExporting}
            >
              {isExcelExporting ? (
                <>
                  <Download className="w-4 h-4 mr-2 animate-spin" />
                  Exporting Excel...
                </>
              ) : (
                <>
                  <FileSpreadsheet className="w-4 h-4 mr-2" />
                  Download Excel
                </>
              )}
            </Button>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t">
          <p className="text-xs text-gray-500 text-center">
            Files will be downloaded to your default download folder
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};